import {Controller} from "@hotwired/stimulus";
import debounce from "lodash/debounce";

/*
  This is one-trick pony that handles the dashboard charts.
  It is unlikely to be used anywhere else.
*/

export default class extends Controller {
  static targets = [
    'chartControls',
    'chartContentError',
    'chartContentSampling',
  ];

  connect() {
    super.connect();
    this._resizeHeadings();

    /* we need to listen for the chart:loaded event to resize headings.
       This event is timed to the actual chart load on monitorResize.
       All other events are too early.
       See app/frontend/elm_ports.js */
    this.chartLoadHandler = this._elmChartLoaded.bind(this)
    this.element.addEventListener('chart:loaded', this.chartLoadHandler);

    /* We need to listen for the resize event to resize headings.
       This is needed because the chart controls can change the size/position of the headings */
    this.resizeListener = this._resizeListener.bind(this);
    window.addEventListener('resize', debounce(this.resizeListener, 100));
  }

  disconnect() {
    super.disconnect();
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('chart:loaded', this.chartLoadHandler);
    this.chartObserver && this.chartObserver.disconnect();
  }


  /* This method is called when the chart content container is loaded.
     We need to resize the headings to fit the chart controls */
  _elmChartLoaded(event) {
    this.chartObserver = new MutationObserver((mutations, observer) => {
      if (event.detail.chartContainer) {
        this._resizeHeadings();
        observer.disconnect();
      }
    });
    this.chartObserver.observe(this.element, {
      childList: true,
      subtree: true
    });
  }

  _resizeListener() {
    this._resizeHeadings();
  }

  /* This method resizes the headings based on the chart controls and chart content error. */
  _resizeHeadings() {
    const h1 = this.element.querySelector('h1');
    const h2 = this.element.querySelector('h2');
    const margins = {
      left: 0,
      right: 0
    };

    /* Make space for chart controls and chart content error */
    /* Check chartControlsTarget opacity,
       if browser does not support hover, it will be 1.
    */

    if (this.hasChartControlsTarget && window.getComputedStyle(this.chartControlsTarget).opacity === '1') {
      margins.right = this.chartControlsTarget.getBoundingClientRect().width;
    }

    if (this.hasChartContentErrorTarget) {
      margins.left = this.chartContentErrorTarget.getBoundingClientRect().width * 1.7;
    }

    if (this.hasChartContentSamplingTarget) {
      margins.left += this.chartContentSamplingTarget.getBoundingClientRect().width * 1.7;
    }

    /* Make sure that headings exist before applying styles */

    if (h1) {
      h1.classList.add('no-hover:text-left');
      h1.style.marginRight = `${margins.right}px`;
      h1.style.marginLeft = `${margins.left}px`;
    }

    if (h2) {
      h2.classList.add('no-hover:text-left');
      h2.style.marginRight = `${margins.right}px`;
      h2.style.marginLeft = `${margins.left}px`;
    }
  }
}